import { SortingState } from '@tanstack/react-table';
import { useQuery } from 'react-query';
import { NarrativeRequest } from 'utilitys/narrative/narrativeTools';

import { getTopOverrunActivities as queryFn } from 'api/endPoints/getTopOverrunActivities';
import { ISingleSmallCardResponse } from 'api/queries/getListFilteredCards.query';
import { QueryKeys } from 'api/queryKeys';

import { Pagination } from 'components/common/pagination/customPagination';

import { IFilter } from 'components/Dashboards/Project/Components/CustomDashboard/utils/utils.type';

export const useQueryGetTopOverrunActivities = (params: QueryParams) => {
    return useQuery<QueryFnResponse, QueryError, QueryResponse, [QueryKeys, unknown]>({
        queryKey: ['getTopOverrunActivities', params],
        queryFn: () => queryFn(params),
        enabled: Boolean(params.id) && Boolean(params.comparedVersionId),
    });
};

export interface QueryParams extends NarrativeRequest {
    id: number[];
    comparedVersionId: number;
    filter: {
        filters: IFilter[];
    };
    sortingRequestList: SortingState;
    paging: Pagination;
}

export interface QueryFnResponse {
    delayDrivers: {
        activityId: string;
        activityName: string;
        activityStatus: null;
        activityType: string;
        actualDuration: number;
        actualFinishDate: null;
        actualStartDate: null;
        baselineFinishDate: number;
        baselineStartDate: number;
        cardBoardViewResponse: ISingleSmallCardResponse;
        clusterId: null;
        completedDuration: number;
        contractName: null;
        criticalPath: boolean;
        criticalityScore: number;
        currentFinishDate: number;
        currentStartDate: number;
        delayDriver: boolean;
        durationOverun: number;
        float: number;
        forecastDuration: null;
        forecastOverrun: null;
        grandParentName: string;
        id: number;
        lateFinish: number;
        lateStart: number;
        metaDataId: number;
        numOfPredecessors: number;
        numOfSuccessors: number;
        originalStatus: null;
        overrunDays: number;
        overrunPercent: number;
        parentName: string;
        percentileRank: number;
        plannedDuration: number;
        plannedFinishDate: number;
        plannedStartDate: number;
        projectMonthFinish: number;
        projectMonthStart: number;
        projectName: null;
        projectWeekFinish: number;
        projectWeekStart: number;
        remainingDuration: number;
        status: null;
        taskHashCode: null;
        taskId: null;
        taskVersionHashCode: string;
        versionName: null;
    }[];
    finishDate: null;
    info: IToolTip;
    numOfPages: number;
    numOfRows: number;
    startDate: null;
}

type QueryResponse = QueryFnResponse & {};
